<script setup lang="ts">
import type { PaymentToken } from "mws-ts-v2-sdk";

const { tokens } = defineProps<{ tokens: PaymentToken[] }>();

const emit = defineEmits<{ (e: "card-selected", token: PaymentToken): void }>();

const isTokensDropdownOpen = ref(false);
const toggleTokens = () => {
  isTokensDropdownOpen.value = !isTokensDropdownOpen.value;
};

const selectedTokenId = ref<string>();
const selectedToken = computed(() =>
  tokens.find((token) => token.id === selectedTokenId.value),
);

onMounted(() => (selectedTokenId.value = tokens[0]?.id));

const onSelectCard = (token: PaymentToken) => {
  selectedTokenId.value = token.id;
  emit("card-selected", token);

  toggleTokens();
};
</script>

<template>
  <div v-if="selectedToken">
    <button
      class="border rounded-sm w-full px-5 py-3 flex justify-between gap-2"
      @click="toggleTokens()"
    >
      <div class="flex gap-2">
        <UserPaymentTokenCardNumberDisplay
          :card-number="selectedToken.cardNumber"
        />
        <span v-if="!selectedToken.isTokenized">
          ({{ $t("myAccount.payment.processing") }})
        </span>
      </div>
      <BaseIcon
        v-if="tokens.length > 1"
        :name="isTokensDropdownOpen ? 'chevronUp' : 'chevronDown'"
        :size="20"
      />
    </button>
    <div
      v-if="tokens.length > 1"
      v-show="isTokensDropdownOpen"
      class="border-x border-b rounded-sm bg-white w-[calc(100%-2rem)] absolute z-10 max-h-40 overflow-y-scroll"
    >
      <ul>
        <li
          v-for="token in tokens"
          :key="token.id"
        >
          <button
            v-if="token.id !== selectedToken?.id"
            class="w-full px-5 py-3 justify-start flex hover:bg-platform-bg-2 gap-2"
            @click="() => onSelectCard(token)"
          >
            <UserPaymentTokenCardNumberDisplay
              :card-number="token.cardNumber"
            />
          </button>
        </li>
      </ul>
    </div>
  </div>
  <p
    v-if="!selectedToken?.isTokenized"
    class="text-sm text-platform-text-2"
  >
    {{ $t("product.cardReservationMessage.processing") }}
  </p>
</template>
